import React from 'react';
import { ConsultationForm } from '../forms/ConsultationForm';
export function FinalCtaSection() {
  return <section className="w-full bg-brand-tealDark" data-id="element-61" data-mp="23m8p1w0q2ql6">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-24" data-id="element-62" data-mp="23njstvu63yca">
        <div data-id="element-63" data-mp="2dj3iw1m1w2t4">
          <h2 className="font-display text-3xl text-white sm:text-4xl" data-id="element-64" data-mp="2dik2wqfynohq">Ready To Get Started?</h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-white/80" data-id="element-65" data-mp="2rhtj3q462ilp">
            Contact Granite &amp; Marble Works today to learn more about our countertop
            replacement process.
          </p>
        </div>

        <ConsultationForm id="get-started" title="Get A Free Consultation" variant="dark" data-id="element-66" data-mp="31b0kkzvsdegi" />
      </div>
    </section>;
}